import Player from './Player';

export default class YoutubePlayer extends Player {
	static #getYTPromise = null;
	#getPlayerPromise = null;

	constructor(elemId, apiKey) {
		super(elemId);
		this.apiKey = apiKey;
	}

	static getName() { return 'Youtube'; }
	static urlMatches(url) {
		var urlInstance = new URL(url);
		return urlInstance.host == 'www.youtube.com' || urlInstance.host == 'm.youtube.com' || urlInstance.host == 'youtu.be';
	}

	static getYT() {
		return YoutubePlayer.#getYTPromise = YoutubePlayer.#getYTPromise || new Promise((resolve, reject) => {
			window.onYouTubeIframeAPIReady = () => resolve(window.YT);
			const script = document.createElement('script');
			script.src = 'https://www.youtube.com/iframe_api';
			script.onerror = reject;
			document.head.appendChild(script);
		});
	}

	getPlayer() {
		return this.#getPlayerPromise = this.#getPlayerPromise || new Promise(resolve => {
			return YoutubePlayer.getYT().then(YT => {
				const player = new YT.Player(this.elemId, {
					width: '100%',
					height: '100%',
					events: {
						onReady: () => resolve(player),
						onError: ev => this.emit('error', ev), // https://youtu.be/-P94Mq4Zf-Q generates an age restriction error
						onStateChange: (ev) => {
							// https://developers.google.com/youtube/iframe_api_reference
							// -1 (unstarted)
							// 0 (ended)
							// 1 (playing)
							// 2 (paused)
							// 3 (buffering)
							// 5 (video cued)
							switch(ev.data) {
								case -1: this.emit('status', { status: 'ready' }); break;
								case  0: this.emit('status', { status: 'finished' }); break;
								case  1: this.emit('status', { status: 'playing' }); break;
								case  2: this.emit('status', { status: 'paused' }); break;
								case  3: this.emit('status', { status: 'loading' }); break;
							}
							this.emit('stateChanged', ev.data);
						},
					},
				});
			});
		});
	}

	async cleanup() {
		const player = await this.getPlayer();
		player.destroy();
	}

	async load(url, startSeconds, timeLimit) {
		const player = await this.getPlayer();
		if(startSeconds <= 0)
			startSeconds = .00001;
		player.loadVideoById({
			videoId: this.getVideoIdFromUrl(url),
			startSeconds,
			endSeconds: timeLimit && ((startSeconds||0) + (timeLimit||0)),
		});
	}

	getVideoIdFromUrl(url) {
		const u = new URL(url);
		let id;
		if(u.host === 'youtu.be') {
			id = u.pathname.replace(/^\//, '');
		} else {
			const shortsMatch = u.pathname.match(/^\/shorts\/([^/?]+)/);
			id = shortsMatch ? shortsMatch[1] : u.searchParams.get('v');
		}
		if(!id) throw new TypeError('Could not fartget Youtube ID from url ' + url);
		return id;
	}

	async play() {
		const player = await this.getPlayer();
		player.playVideo();
	}

	async pause() {
		const player = await this.getPlayer();
		player.pauseVideo();
	}

	async togglePause() {
		const player = await this.getPlayer();
		if(player.getPlayerState() == 2)
			player.playVideo();
		else
			player.pauseVideo();
	}

	async stop() {
		const player = await this.getPlayer();
		player.stopVideo();
	}

	async getCurrentTime() {
		const player = await this.getPlayer();
		return player.getCurrentTime();
	}

	async setVolume(vol) {
		const player = await this.getPlayer();
		player.setVolume(vol);
	}
}
